import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';

export function useHasAdvisorLogoBranding() {
  const { flags } = useFeatureFlags();

  return !!flags.advisorLogoBranding;
}
